export default __webpack_public_path__ + "static/media/pause.ecf1bc0a.svg";